import { apiGet, apiPatch } from './client';
import type { CreditSourceGroup, CreditSourceGroupBatchRequest } from '../types/CreditSourceGroup';

export function getCreditSourceGroups(): Promise<CreditSourceGroup[]> {
  return apiGet<CreditSourceGroup[]>('/api/credit-source-groups');
}

export function saveBatchCreditSourceGroups(
  added: CreditSourceGroup[],
  modified: CreditSourceGroup[],
  deletedIds: number[],
): Promise<CreditSourceGroup[]> {
  return apiPatch<CreditSourceGroupBatchRequest, CreditSourceGroup[]>(
    '/api/credit-source-groups/batch',
    { added, modified, deleted: deletedIds },
  );
}
